module.exports = "/images/global@3x.png?5c59be7946e3a6ce5f0c1f06c47cfff8";